export enum NotificationErrorCode {
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  NOT_AUTHENTICATED = 'NOT_AUTHENTICATED',
  INCORRECT_LOGIN_DETAILS = 'INCORRECT_LOGIN_DETAILS',
  INCORRECT_OLD_PASSWORD = 'INCORRECT_OLD_PASSWORD',
  USER_ALREADY_EXISTS = 'USER_ALREADY_EXISTS',
  PASS_ALREADY_EXISTS = 'PASS_ALREADY_EXISTS',
  VERIFY_TOKEN_INVALID = 'VERIFY_TOKEN_INVALID',
  FORBIDDEN = 'FORBIDDEN',
  INTEGRATION_OAUTH_FAILED_ERROR = 'INTEGRATION_OAUTH_FAILED_ERROR',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  PERMISSION_ALREADY_EXISTS = 'PERMISSION_ALREADY_EXISTS',
  SITE_NAME_NOT_IDENTICAL = 'SITE_NAME_NOT_IDENTICAL',
  SITE_CHECKIN_DISABLED = 'SITE_CHECKIN_DISABLED',
  INVALID_PASS_STATUS = 'INVALID_PASS_STATUS',
  USER_VERIFICATION_REQUIRED = 'USER_VERIFICATION_REQUIRED',
  EMAIL_INVALID = 'EMAIL_INVALID',
}
